var render = function render(_c,_vm){return _c('div',{staticClass:"layout-center"},[_c('div',{staticClass:"layout-center__heading"},[_vm._t("heading")],2),_c('div',{staticClass:"layout-center__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }